import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router';
import { message } from 'antd';
import { UserContext } from '../../App'
import { Pie, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import { getAllSubcontractor } from "../../webServices/Apis"
import Loader from '../Loader/Loader';
// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

const Dashboard = () => {
  const { setIsAuthenticated } = useContext(UserContext);
  const [contractors, setContractors] = useState('')
  const [totalContractors, setTotalContractors] = useState(0);
  const [inactive, setInactive] = useState(0);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Data for Pie Chart
  const pieData = {
    labels: ['Red', 'Blue', 'Yellow'],
    datasets: [
      {
        label: 'User Distribution',
        data: [12, 19, 3],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  };

  // Data for Bar Chart
  const barData = {
    labels: ['January', 'February', 'March', 'April', 'May'],
    datasets: [
      {
        label: 'Created Users',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        borderWidth: 1,
        hoverBackgroundColor: '#36A2EB',
        hoverBorderColor: '#36A2EB',
        data: [65, 59, 80, 81, 56],
      },
      {
        label: 'Deleted Users',
        backgroundColor: '#FF6384',
        borderColor: '#FF6384',
        borderWidth: 1,
        hoverBackgroundColor: '#FF6384',
        hoverBorderColor: '#FF6384',
        data: [28, 48, 40, 19, 86],
      },
    ],
  };
  const fetchContractors = async () => {
    try {
      setLoading(true);
      const response = await getAllSubcontractor();
      let activeCount = 0;
      let inactiveCount = 0;
      if (response.data.success) {
        setTotalContractors(response?.data?.data?.length);

        response.data.data.forEach((contractor) => {
          if (contractor?.active) {
            activeCount++;
          } else {
            inactiveCount++;
          }
        });
        setActive(activeCount);
        setInactive(inactiveCount)

        setContractors(response?.data?.data);
      }
    } catch (error) {
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.removeItem('token');
        setIsAuthenticated(false)
        navigate("/login")
        return;
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired")
        localStorage.clear()
        setIsAuthenticated(false)
        navigate("/login")
        return;
      } else {
        return;
      }

      // message.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const hanldeActiveUsers = () => {
   
    navigate('/active', {state: {contractors}})
    
  }

  const hanldeInactiveUsers = () => {
  
    navigate('/inactive', {state: {contractors}})
    
  }


  // Listen for back button and redirect to /home
  useEffect(() => {
    const handlePopState = () => {
      navigate('/home'); // Redirect to /home when the back button is pressed
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);


  useEffect(() => {
    fetchContractors();
  }, []);
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold">Dashboard</h2>
      {loading && (
        <Loader />
      )}
      <p>Welcome to the admin dashboard!</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-4">
        <div className="bg-gradient-to-r from-purple-400 to-blue-500 text-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
          onClick={() => navigate("/subcontractor")}
        >
          <h3 className="text-lg font-semibold">Total Sub Contractors</h3>
          <p className="text-4xl font-bold">{totalContractors}</p>
          <p className="mt-2 text-sm">Total number of registered Sub contractors</p>
        </div>
        <div className="bg-gradient-to-r from-green-400 to-teal-500 text-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
          onClick={hanldeActiveUsers}
        >
          <h3 className="text-lg font-semibold">Active Sub Contractors</h3>
          {/* {console.log("active....", active)} */}
          <p className="text-4xl font-bold">{active}</p>
          <p className="mt-2 text-sm">Currently active Sub contractors</p>
        </div>
        <div className="bg-gradient-to-r from-red-400 to-pink-500 text-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
          onClick={hanldeInactiveUsers}
        >
          <h3 className="text-lg font-semibold">Inactive Sub Contractors</h3>
          <p className="text-4xl font-bold">{inactive}</p>
          <p className="mt-2 text-sm">Sub Contractors who are inactive</p>
        </div>
      </div>

    </div>
  );
};
export default Dashboard;
